export enum Role {
  AD = 'Admin',
  CS = 'Customer Service Rep',
  MA = 'Medical Assistant',
  MD = 'Master Physician',
  NP = 'Nurse Practitioner',
  PH = 'Physician'
}

export enum RoleShortName {
  Admin = 'AD',
  CustomerService = 'CS',
  MasterPhysician = 'MD',
  MedicalAssistant = 'MA',
  NursePractitioner = 'NP',
  Physician = 'PH'
}
